// Central runtime config for the storefront.
// Set REACT_APP_API_URL in a .env file to point at your backend.
export const API_URL = 'https://api-mindblown.threadique.live/api';

// Default store settings — used until /settings loads (or if the API is down),
// so the site always renders. The admin panel can override all of these.
export const DEFAULT_SETTINGS = {
  storeName: 'Mind Blown',
  currency: 'GBP',
  currencySymbol: '£',
  taxRatePercent: 20, // VAT
  taxInclusive: false,
  freeShippingThreshold: 75,
  shippingFlatRate: 8.99,
  ageRequirement: 18,
  supportEmail: 'hello@mindblownus.com',
};
